import axios from 'axios';
import { BASE_TASK_STATUS } from '../components/constants';


// Create a new task status
export const createTaskStatus = async (taskStatusData) => {
    try {
        const response = await axios.post(`${BASE_TASK_STATUS}/create`, taskStatusData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get task statuses by history ID
export const getTaskStatusesByHistory = async (historyId) => {
    try {
        const response = await axios.get(`${BASE_TASK_STATUS}/${historyId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update task status
export const updateTaskStatus = async (taskStatusData) => {
    try {
        const response = await axios.put(`${BASE_TASK_STATUS}/update`, taskStatusData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete task status
export const deleteTaskStatus = async (taskStatusData) => {
    try {
        const response = await axios.delete(`${BASE_TASK_STATUS}/delete`, {
            data: taskStatusData
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
